import { Br, Cut, Line, Printer, QRCode, Row, Text, render } from "react-thermal-printer";
import { getFromLocalStorage } from "../../../../../../utils/localStorageHelpers";
import { convertToLocalDateTime, convertToLocalTime } from "../../Middleware/commonUtils";
import { UserContext } from "../../../../../../App";
import { Fragment, useContext } from "react";
import {
  renderFooter,
  renderFooter001_01,
  renderFooter004,
  renderFooter006,
  renderFooter007,
  renderOrderDetails,
  renderOrderDetails004,
  renderOrderDetails005,
  renderOrderHeader,
  renderOrderHeader004,
  renderOrderHeader005,
  renderOrderHeader006,
  renderOrderHeader006_01,
  renderOrderHeader007,
  renderOrderItemsGst,
  renderOrderItemsGst002_02,
  renderOrderItemsGst004,
  renderOrderItemsGst005,
  renderOrderItemsGst006,
  renderOrderItemsGst006_01,
  renderOrderItemsGst007,
  renderOrderItemsList,
  renderPaymentDetails,
  renderPaymentDetails006,
  renderReturnedItemsDetails,
  renderReturnedItemsDetails002_02,
  renderReturnedItemsDetails004,
  renderStoreDetails,
  renderStoreDetails006,
  renderStoreDetails006_01,
  renderStoreDetails007,
  renderStoreDetails008,
  renderTaxBreakup,
  renderToken,
  renderToken002,
  renderToken006,
  renderToken007,
} from "./renderComponents";

const appConfigData = localStorage.getItem("appConfig");
const appConfig = appConfigData ? JSON.parse(localStorage.getItem("appConfig")) : {};
const isKOTRequired = appConfig?.settings?.DISPLAY_SYSTEM_MODE?.kdsDisplayScreens?.includes("KOT");

export const renderTemplate001 = async (props) => {
  const {
    printerWidth,
    retailDetails,
    baseOrderResponse,
    baseDetails,
    gstBreakupDetails,
    cessItems,
    noGst,
    gst2slab,
    gst1slab,
    gst5slab,
    gst6slab,
    gst9slab,
    gst14slab,
    gst20slab,
    freeProducts,
    isB2cOrder,
    isDeliveryOrder,
    reprint,
    orderId,
    invoiceId,
    date,
    totalQuantity,
    orgConfig,
    deliveryAddress,
    cashDrawerOpen,
    returnId,
    printType,
    saleMode,
    tokenNumber,
  } = props;

  const template003 = false;
  return (
    <Printer type="epson" width={printerWidth}>
      {/* Store details */}
      {renderStoreDetails(retailDetails)}

      {/* Order header */}
      {renderOrderHeader(
        isB2cOrder,
        isDeliveryOrder,
        reprint,
        orderId,
        invoiceId,
        baseOrderResponse,
        baseDetails,
        date,
        returnId,
        printType
      )}

      {/* Order items */}
      {renderOrderItemsGst(
        noGst,
        gst1slab,
        gst2slab,
        gst5slab,
        gst6slab,
        gst9slab,
        gst14slab,
        gst20slab,
        freeProducts
      )}

      {/* Order details */}
      {renderOrderDetails(
        { isB2cOrder, baseOrderResponse, totalQuantity, printType, baseDetails },
        template003
      )}

      {/* Payment details */}
      {renderPaymentDetails(baseOrderResponse, baseDetails, printType)}

      {/* Tax Breakup */}
      {renderTaxBreakup(gstBreakupDetails, cessItems)}

      {/* B2C Order */}

      {isB2cOrder && renderReturnedItemsDetails(baseOrderResponse?.orderItemList)}

      {/* Footer */}
      {renderFooter(
        {
          isB2cOrder,
          isDeliveryOrder,
          baseOrderResponse,
          deliveryAddress,
          cashDrawerOpen,
          printType,
          baseDetails,
          saleMode,
        },
        template003
      )}

      {/* token */}
      {isKOTRequired &&
        renderToken(
          tokenNumber,
          noGst,
          gst1slab,
          gst2slab,
          gst5slab,
          gst6slab,
          gst9slab,
          gst14slab,
          freeProducts
        )}
    </Printer>
  );
};

export const renderTemplate001_01 = async (props) => {
  const {
    printerWidth,
    retailDetails,
    baseOrderResponse,
    baseDetails,
    gstBreakupDetails,
    cessItems,
    noGst,
    gst2slab,
    gst1slab,
    gst5slab,
    gst6slab,
    gst9slab,
    gst14slab,
    gst20slab,
    freeProducts,
    isB2cOrder,
    isDeliveryOrder,
    reprint,
    orderId,
    invoiceId,
    date,
    totalQuantity,
    orgConfig,
    deliveryAddress,
    cashDrawerOpen,
    returnId,
    printType,
    saleMode,
    tokenNumber,
  } = props;

  const template003 = false;
  return (
    <Printer type="epson" width={printerWidth}>
      {/* Store details */}
      {renderStoreDetails(retailDetails)}

      {/* Order header */}
      {renderOrderHeader(
        isB2cOrder,
        isDeliveryOrder,
        reprint,
        orderId,
        invoiceId,
        baseOrderResponse,
        baseDetails,
        date,
        returnId,
        printType
      )}

      {/* Order items */}
      {renderOrderItemsGst(
        noGst,
        gst1slab,
        gst2slab,
        gst5slab,
        gst6slab,
        gst9slab,
        gst14slab,
        gst20slab,
        freeProducts
      )}

      {/* Order details */}
      {renderOrderDetails(
        { isB2cOrder, baseOrderResponse, totalQuantity, printType, baseDetails },
        template003
      )}

      {/* Payment details */}
      {renderPaymentDetails(baseOrderResponse, baseDetails, printType)}

      {/* Tax Breakup */}
      {renderTaxBreakup(gstBreakupDetails, cessItems)}

      {/* B2C Order */}

      {isB2cOrder && renderReturnedItemsDetails(baseOrderResponse?.orderItemList)}

      {/* Footer */}
      {renderFooter001_01(
        {
          isB2cOrder,
          isDeliveryOrder,
          baseOrderResponse,
          deliveryAddress,
          cashDrawerOpen,
          printType,
          baseDetails,
          saleMode,
        },
        template003
      )}

      {/* token */}
      {isKOTRequired &&
        renderToken(
          tokenNumber,
          noGst,
          gst1slab,
          gst2slab,
          gst5slab,
          gst6slab,
          gst9slab,
          gst14slab,
          freeProducts
        )}
    </Printer>
  );
};

// template_001_02 — identical to template_001 except the item table drops the MRP and Rate
// columns and shows a running serial number instead of the HSN code.
export const renderTemplate002_02 = async (props) => {
  const {
    printerWidth,
    retailDetails,
    baseOrderResponse,
    baseDetails,
    gstBreakupDetails,
    cessItems,
    noGst,
    gst2slab,
    gst1slab,
    gst5slab,
    gst6slab,
    gst9slab,
    gst14slab,
    gst20slab,
    freeProducts,
    isB2cOrder,
    isDeliveryOrder,
    reprint,
    orderId,
    invoiceId,
    date,
    totalQuantity,
    orgConfig,
    deliveryAddress,
    cashDrawerOpen,
    returnId,
    printType,
    saleMode,
    tokenNumber,
  } = props;

  const template003 = false;
  return (
    <Printer type="epson" width={printerWidth}>
      {/* Store details */}
      {renderStoreDetails(retailDetails)}

      {/* Order header */}
      {renderOrderHeader(
        isB2cOrder,
        isDeliveryOrder,
        reprint,
        orderId,
        invoiceId,
        baseOrderResponse,
        baseDetails,
        date,
        returnId,
        printType
      )}

      {/* Order items — no MRP / Rate columns */}
      {renderOrderItemsGst002_02(
        noGst,
        gst1slab,
        gst2slab,
        gst5slab,
        gst6slab,
        gst9slab,
        gst14slab,
        gst20slab,
        freeProducts
      )}

      {/* Order details */}
      {renderOrderDetails(
        { isB2cOrder, baseOrderResponse, totalQuantity, printType, baseDetails },
        template003
      )}

      {/* Payment details */}
      {renderPaymentDetails(baseOrderResponse, baseDetails, printType)}

      {/* Tax Breakup */}
      {renderTaxBreakup(gstBreakupDetails, cessItems)}

      {/* B2C Order */}

      {isB2cOrder && renderReturnedItemsDetails002_02(baseOrderResponse?.orderItemList)}

      {/* Footer */}
      {renderFooter(
        {
          isB2cOrder,
          isDeliveryOrder,
          baseOrderResponse,
          deliveryAddress,
          cashDrawerOpen,
          printType,
          baseDetails,
          saleMode,
        },
        template003
      )}

      {/* token */}
      {isKOTRequired &&
        renderToken(
          tokenNumber,
          noGst,
          gst1slab,
          gst2slab,
          gst5slab,
          gst6slab,
          gst9slab,
          gst14slab,
          freeProducts
        )}
    </Printer>
  );
};

export const renderTemplate002 = async (props) => {
  const {
    printerWidth,
    retailDetails,
    baseOrderResponse,
    baseDetails,
    gstBreakupDetails,
    cessItems,
    orderItems,
    isB2cOrder,
    isDeliveryOrder,
    reprint,
    orderId,
    invoiceId,
    noGst,
    gst2slab,
    gst1slab,
    gst5slab,
    gst6slab,
    gst9slab,
    gst14slab,
    gst20slab,
    freeProducts,

    date,
    totalQuantity,
    orgConfig,
    deliveryAddress,
    cashDrawerOpen,
    returnId,
    printType,
    saleMode,
    tokenNumber,
    useVariantName = false,
  } = props;
  const itemSno = false;
  const template003 = false;

  return (
    <Printer type="epson" width={printerWidth}>
      {/* Store details */}
      {renderStoreDetails(retailDetails)}

      {/* Order header */}
      {renderOrderHeader(
        isB2cOrder,
        isDeliveryOrder,
        reprint,
        orderId,
        invoiceId,
        baseOrderResponse,
        baseDetails,
        date,
        returnId,
        printType
      )}

      {/* Order items */}
      {renderOrderItemsList(orderItems, itemSno, useVariantName)}

      {/* Order details */}
      {renderOrderDetails(
        { isB2cOrder, baseOrderResponse, totalQuantity, printType, baseDetails },
        template003
      )}

      {/* Payment details */}
      {renderPaymentDetails(baseOrderResponse, baseDetails, printType)}

      {/* Tax Breakup */}
      {renderTaxBreakup(gstBreakupDetails, cessItems)}

      {/* B2C Order */}

      {isB2cOrder &&
        renderReturnedItemsDetails(baseOrderResponse?.orderItemList, false, useVariantName)}

      {/* Footer */}
      {renderFooter(
        {
          isB2cOrder,
          isDeliveryOrder,
          baseOrderResponse,
          deliveryAddress,
          cashDrawerOpen,
          printType,
          baseDetails,
          saleMode,
        },
        template003
      )}

      {isKOTRequired &&
        renderToken(
          tokenNumber,
          noGst,
          gst1slab,
          gst2slab,
          gst5slab,
          gst6slab,
          gst9slab,
          gst14slab,
          freeProducts
        )}
    </Printer>
  );
};

// template_002_01 — identical to template_002 except items print the variant name instead of
// the product name.
export const renderTemplate002_01 = async (props) =>
  renderTemplate002({ ...props, useVariantName: true });

export const renderTemplate003 = async (props) => {
  const {
    printerWidth,
    retailDetails,
    baseOrderResponse,
    baseDetails,
    orderItems,
    isB2cOrder,
    isDeliveryOrder,
    reprint,
    orderId,
    invoiceId,
    noGst,
    gst2slab,
    gst1slab,
    gst5slab,
    gst6slab,
    gst9slab,
    gst14slab,
    gst20slab,
    freeProducts,

    date,
    totalQuantity,
    orgConfig,
    deliveryAddress,
    cashDrawerOpen,
    returnId,
    printType,
    saleMode,
    tokenNumber,
  } = props;
  const itemSno = true;
  const template003 = true;

  return (
    <Printer type="epson" width={printerWidth}>
      {/* Store details */}
      {renderStoreDetails(retailDetails)}

      {/* Order header */}
      {renderOrderHeader(
        isB2cOrder,
        isDeliveryOrder,
        reprint,
        orderId,
        invoiceId,
        baseOrderResponse,
        baseDetails,
        date,
        returnId,
        printType
      )}

      {/* Order items */}
      {renderOrderItemsList(orderItems, itemSno)}

      {/* Order details */}
      {renderOrderDetails(
        { isB2cOrder, baseOrderResponse, totalQuantity, printType, baseDetails },
        template003
      )}

      {/* Payment details */}
      {renderPaymentDetails(baseOrderResponse, baseDetails, printType)}

      {/* B2C Order */}

      {isB2cOrder && renderReturnedItemsDetails(baseOrderResponse?.orderItemList)}

      {/* Footer */}
      {renderFooter(
        {
          isB2cOrder,
          isDeliveryOrder,
          baseOrderResponse,
          deliveryAddress,
          cashDrawerOpen,
          printType,
          baseDetails,
          saleMode,
        },
        template003
      )}

      {isKOTRequired &&
        renderToken(
          tokenNumber,
          noGst,
          gst1slab,
          gst2slab,
          gst5slab,
          gst6slab,
          gst9slab,
          gst14slab,
          freeProducts
        )}
    </Printer>
  );
};

export const renderTemplate004 = async (props) => {
  const {
    printerWidth,
    retailDetails,
    baseOrderResponse,
    baseDetails,
    noGst,
    isB2cOrder,
    isDeliveryOrder,
    reprint,
    orderId,
    invoiceId,
    date,
    totalQuantity,
    gst2slab,
    gst1slab,
    gst5slab,
    gst6slab,
    gst9slab,
    gst14slab,
    gst20slab,
    freeProducts,

    orgConfig,
    deliveryAddress,
    cashDrawerOpen,
    returnId,
    printType,
    saleMode,
    tokenNumber,
  } = props;
  const template003 = false;

  return (
    <Printer type="epson" width={printerWidth}>
      {/* Store details */}
      {renderStoreDetails(retailDetails, true)}

      {/* Order header */}
      {renderOrderHeader004(
        isB2cOrder,
        isDeliveryOrder,
        reprint,
        orderId,
        invoiceId,
        baseOrderResponse,
        baseDetails,
        date,
        returnId,
        printType,
        true
      )}

      {/* Order items */}
      {renderOrderItemsGst004(noGst)}

      {/* Payment details */}
      {renderPaymentDetails(baseOrderResponse, baseDetails, printType)}

      {renderOrderDetails004(
        { isB2cOrder, baseOrderResponse, totalQuantity, printType, baseDetails },
        template003
      )}

      {/* B2C Order */}

      {isB2cOrder && renderReturnedItemsDetails004(baseOrderResponse?.orderItemList)}

      {/* Footer */}
      {renderFooter004(
        {
          isB2cOrder,
          isDeliveryOrder,
          baseOrderResponse,
          deliveryAddress,
          cashDrawerOpen,
          printType,
          baseDetails,
          saleMode,
        },
        template003
      )}

      {isKOTRequired &&
        renderToken(
          tokenNumber,
          noGst,
          gst1slab,
          gst2slab,
          gst5slab,
          gst6slab,
          gst9slab,
          gst14slab,
          freeProducts
        )}
    </Printer>
  );
};

export const renderTemplate005 = async (props) => {
  const {
    printerWidth,
    retailDetails,
    baseOrderResponse,
    baseDetails,
    noGst,
    isB2cOrder,
    isDeliveryOrder,
    reprint,
    orderId,
    invoiceId,
    date,
    totalQuantity,
    orgConfig,
    deliveryAddress,
    cashDrawerOpen,
    returnId,
    printType,
    saleMode,
    tokenNumber,
    gst1slab,
    gst2slab,
    gst5slab,
    gst6slab,
    gst9slab,
    gst14slab,
    gst20slab,
    freeProducts,
  } = props;
  const template003 = false;

  return (
    <Printer type="epson" width={printerWidth}>
      {/* Store details */}
      {renderStoreDetails(retailDetails, true)}

      {/* Order header */}
      {renderOrderHeader005(
        isB2cOrder,
        isDeliveryOrder,
        reprint,
        orderId,
        invoiceId,
        baseOrderResponse,
        baseDetails,
        date,
        returnId,
        printType,
        true
      )}

      {/* Order items */}
      {renderOrderItemsGst005(noGst)}

      {/* Payment details */}
      {renderPaymentDetails(baseOrderResponse, baseDetails, printType)}

      {renderOrderDetails005(
        { isB2cOrder, baseOrderResponse, totalQuantity, printType, baseDetails },
        template003
      )}

      {/* B2C Order */}

      {isB2cOrder && renderReturnedItemsDetails004(baseOrderResponse?.orderItemList)}

      {/* Footer */}
      {renderFooter004(
        {
          isB2cOrder,
          isDeliveryOrder,
          baseOrderResponse,
          deliveryAddress,
          cashDrawerOpen,
          printType,
          baseDetails,
          saleMode,
        },
        template003
      )}
    </Printer>
  );
};

export const renderTemplate006 = async (props) => {
  const {
    printerWidth,
    retailDetails,
    baseOrderResponse,
    baseDetails,
    noGst,
    isB2cOrder,
    gstBreakupDetails,
    isDeliveryOrder,
    reprint,
    orderId,
    invoiceId,
    date,
    totalQuantity,
    gst2slab,
    gst1slab,
    gst5slab,
    gst6slab,
    gst9slab,
    gst14slab,
    gst20slab,
    freeProducts,
    imgBase64,
    orgConfig,
    deliveryAddress,
    cashDrawerOpen,
    returnId,
    printType,
    tokenNumber,
    saleMode,
    branchSubType,
    skipBill = false,
    skipKot = false,
  } = props;
  const template003 = false;

  // Get stored org config for KOT template
  const storedOrgConfig = orgConfig || JSON.parse(localStorage.getItem("orgConfig") || "{}");

  return (
    <Printer type="epson" width={printerWidth}>
      {/* Bill sections - skip if skipBill is true */}
      {!skipBill && (
        <>
          {/* Store details */}
          {renderStoreDetails006(retailDetails, imgBase64)}

          {/* Order header */}
          {renderOrderHeader006(
            isB2cOrder,
            isDeliveryOrder,
            reprint,
            orderId,
            invoiceId,
            baseOrderResponse,
            baseDetails,
            date,
            returnId,
            imgBase64,
            printType,
            saleMode,
            branchSubType,
            tokenNumber
          )}

          {/* Order items */}
          {renderOrderItemsGst006(
            noGst,
            gst1slab,
            gst2slab,
            gst5slab,
            gst6slab,
            gst9slab,
            gst14slab,
            gst20slab,
            freeProducts
          )}

          {/* Payment details */}
          {renderPaymentDetails006(
            baseOrderResponse,
            baseDetails,
            printType,
            gstBreakupDetails,
            saleMode
          )}

          {/* Footer */}
          {renderFooter006(
            {
              isB2cOrder,
              isDeliveryOrder,
              baseOrderResponse,
              deliveryAddress,
              cashDrawerOpen,
              printType,
              baseDetails,
              saleMode,
            },
            template003
          )}
        </>
      )}

      {/* Conditional KOT Token Rendering - skip if skipKot is true */}
      {/* For FINE_DINE: Don't print token if printer agent is connected OR saleMode is DINE_IN */}
      {/* For QSR: Always print token regardless of printer agent connection or saleMode */}
      {!skipKot &&
        (() => {
          let printerAgentConnected = false;

          try {
            printerAgentConnected = JSON.parse(localStorage.getItem("sendToKitchen") || "false");
          } catch {
            printerAgentConnected = false;
          }

          const shouldPrintToken =
            branchSubType !== "FINE_DINE" || (!printerAgentConnected && saleMode !== "DINE_IN");

          return (
            shouldPrintToken &&
            (storedOrgConfig?.kotTemplateId === "token002"
              ? renderToken002(
                  baseOrderResponse,
                  tokenNumber,
                  noGst,
                  gst1slab,
                  gst2slab,
                  gst5slab,
                  gst6slab,
                  gst9slab,
                  gst14slab,
                  gst20slab,
                  freeProducts
                )
              : renderToken(
                  baseOrderResponse,
                  tokenNumber,
                  noGst,
                  gst1slab,
                  gst2slab,
                  gst5slab,
                  gst6slab,
                  gst9slab,
                  gst14slab,
                  gst20slab,
                  freeProducts
                ))
          );
        })()}
    </Printer>
  );
};

// Same layout as template_006 — starting point for client-specific customizations.
export const renderTemplate006_01 = async (props) => {
  const {
    printerWidth,
    retailDetails,
    baseOrderResponse,
    baseDetails,
    noGst,
    isB2cOrder,
    gstBreakupDetails,
    isDeliveryOrder,
    reprint,
    orderId,
    invoiceId,
    date,
    totalQuantity,
    gst2slab,
    gst1slab,
    gst5slab,
    gst6slab,
    gst9slab,
    gst14slab,
    gst20slab,
    freeProducts,
    imgBase64,
    orgConfig,
    deliveryAddress,
    cashDrawerOpen,
    returnId,
    printType,
    tokenNumber,
    saleMode,
    branchSubType,
    skipBill = false,
    skipKot = false,
  } = props;
  const template003 = false;

  // Get stored org config for KOT template
  const storedOrgConfig = orgConfig || JSON.parse(localStorage.getItem("orgConfig") || "{}");

  return (
    <Printer type="epson" width={printerWidth}>
      {/* Bill sections - skip if skipBill is true */}
      {!skipBill && (
        <>
          {/* Store details */}
          {renderStoreDetails006_01(retailDetails, imgBase64, isB2cOrder)}

          {/* Order header — includes Order Id (billSequence, falls back to orderId) */}
          {renderOrderHeader006_01(
            isB2cOrder,
            isDeliveryOrder,
            reprint,
            orderId,
            invoiceId,
            baseOrderResponse,
            baseDetails,
            date,
            returnId,
            imgBase64,
            printType,
            saleMode,
            branchSubType,
            tokenNumber
          )}

          {/* Order items — full product name, bold description */}
          {renderOrderItemsGst006_01(
            noGst,
            gst1slab,
            gst2slab,
            gst5slab,
            gst6slab,
            gst9slab,
            gst14slab,
            gst20slab,
            freeProducts
          )}

          {/* Payment details */}
          {renderPaymentDetails006(
            baseOrderResponse,
            baseDetails,
            printType,
            gstBreakupDetails,
            saleMode
          )}

          {/* Footer */}
          {renderFooter006(
            {
              isB2cOrder,
              isDeliveryOrder,
              baseOrderResponse,
              deliveryAddress,
              cashDrawerOpen,
              printType,
              baseDetails,
              saleMode,
            },
            template003,
            "Thanks for Ordering!", //footer message
            true, // hide customer mobile in the delivery section
            true // bold footer message
          )}
        </>
      )}

      {/* Conditional KOT Token Rendering - skip if skipKot is true */}
      {/* For FINE_DINE: Don't print token if printer agent is connected OR saleMode is DINE_IN */}
      {/* For QSR: Always print token regardless of printer agent connection or saleMode */}
      {!skipKot &&
        (() => {
          let printerAgentConnected = false;

          try {
            printerAgentConnected = JSON.parse(localStorage.getItem("sendToKitchen") || "false");
          } catch {
            printerAgentConnected = false;
          }

          const shouldPrintToken =
            branchSubType !== "FINE_DINE" || (!printerAgentConnected && saleMode !== "DINE_IN");

          return (
            shouldPrintToken &&
            (storedOrgConfig?.kotTemplateId === "token002"
              ? renderToken002(
                  baseOrderResponse,
                  tokenNumber,
                  noGst,
                  gst1slab,
                  gst2slab,
                  gst5slab,
                  gst6slab,
                  gst9slab,
                  gst14slab,
                  gst20slab,
                  freeProducts
                )
              : renderToken(
                  baseOrderResponse,
                  tokenNumber,
                  noGst,
                  gst1slab,
                  gst2slab,
                  gst5slab,
                  gst6slab,
                  gst9slab,
                  gst14slab,
                  gst20slab,
                  freeProducts
                ))
          );
        })()}
    </Printer>
  );
};

export const renderTemplate007 = async (props) => {
  const {
    printerWidth,
    retailDetails,
    baseOrderResponse,
    baseDetails,
    noGst,
    isB2cOrder,
    gstBreakupDetails,
    isDeliveryOrder,
    reprint,
    orderId,
    invoiceId,
    date,
    totalQuantity,
    gst2slab,
    gst1slab,
    gst5slab,
    gst6slab,
    gst9slab,
    gst14slab,
    gst20slab,
    freeProducts,
    imgBase64,
    orgConfig,
    deliveryAddress,
    cashDrawerOpen,
    returnId,
    printType,
    tokenNumber,
    saleMode,
    branchSubType,
    skipBill = false,
    skipKot = false,
  } = props;
  const template003 = false;

  // Get stored org config for KOT template
  const storedOrgConfig = orgConfig || JSON.parse(localStorage.getItem("orgConfig") || "{}");

  return (
    <Printer type="epson" width={printerWidth}>
      {/* Bill sections - skip if skipBill is true */}
      {!skipBill && (
        <>
          {/* Store details */}
          {renderStoreDetails007(retailDetails, imgBase64)}

          {/* Order header */}
          {renderOrderHeader006(
            isB2cOrder,
            isDeliveryOrder,
            reprint,
            orderId,
            invoiceId,
            baseOrderResponse,
            baseDetails,
            date,
            returnId,
            imgBase64,
            printType,
            saleMode,
            branchSubType,
            tokenNumber
          )}

          {/* Order items */}
          {renderOrderItemsGst007(
            noGst,
            gst1slab,
            gst2slab,
            gst5slab,
            gst6slab,
            gst9slab,
            gst14slab,
            gst20slab,
            freeProducts
          )}

          {/* Payment details */}
          {renderPaymentDetails006(
            baseOrderResponse,
            baseDetails,
            printType,
            gstBreakupDetails,
            saleMode
          )}

          {/* Footer */}
          {renderFooter007(
            {
              isB2cOrder,
              isDeliveryOrder,
              baseOrderResponse,
              deliveryAddress,
              cashDrawerOpen,
              printType,
              baseDetails,
              saleMode,
            },
            template003
          )}
        </>
      )}

      {/* Conditional KOT Token Rendering - skip if skipKot is true */}
      {!skipKot &&
        (() => {
          let printerAgentConnected = false;

          try {
            printerAgentConnected = JSON.parse(localStorage.getItem("sendToKitchen") || "false");
          } catch {
            printerAgentConnected = false;
          }

          const shouldPrintToken =
            branchSubType !== "FINE_DINE" || (!printerAgentConnected && saleMode !== "DINE_IN");

          return (
            shouldPrintToken &&
            (storedOrgConfig?.kotTemplateId === "token002"
              ? renderToken002(
                  baseOrderResponse,
                  tokenNumber,
                  noGst,
                  gst1slab,
                  gst2slab,
                  gst5slab,
                  gst6slab,
                  gst9slab,
                  gst14slab,
                  gst20slab,
                  freeProducts
                )
              : renderToken(
                  baseOrderResponse,
                  tokenNumber,
                  noGst,
                  gst1slab,
                  gst2slab,
                  gst5slab,
                  gst6slab,
                  gst9slab,
                  gst14slab,
                  gst20slab,
                  freeProducts
                ))
          );
        })()}
    </Printer>
  );
};

export const resizeImageToBase64 = (base64, targetWidth = 500) => {
  return new Promise((resolve, reject) => {
    if (!base64) {
      resolve(null);
      return;
    }

    const img = new window.Image();

    img.onload = () => {
      const aspectRatio = img.height / img.width;
      const canvas = document.createElement("canvas");
      canvas.width = targetWidth;
      canvas.height = Math.round(targetWidth * aspectRatio);

      const ctx = canvas.getContext("2d");
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      resolve(canvas.toDataURL("image/png"));
    };

    img.onerror = () => reject(new Error("Failed to load image"));
    img.src = base64;
  });
};

export const renderTemplate008 = async (props) => {
  const {
    printerWidth,
    retailDetails,
    baseOrderResponse,
    baseDetails,
    noGst,
    isB2cOrder,
    gstBreakupDetails,
    isDeliveryOrder,
    reprint,
    orderId,
    invoiceId,
    date,
    totalQuantity,
    gst2slab,
    gst1slab,
    gst5slab,
    gst6slab,
    gst9slab,
    gst14slab,
    gst20slab,
    freeProducts,
    imgBase64,
    orgConfig,
    deliveryAddress,
    cashDrawerOpen,
    returnId,
    printType,
    tokenNumber,
    saleMode,
    branchSubType,
    skipBill = false,
    skipKot = false,
  } = props;
  const template003 = false;

  // Get stored org config for KOT template
  const storedOrgConfig = orgConfig || JSON.parse(localStorage.getItem("orgConfig") || "{}");

  let scaledImg = null;

  try {
    scaledImg = await resizeImageToBase64(imgBase64, 500);
  } catch (error) {
    scaledImg = null;
  }

  return (
    <Printer type="epson" width={printerWidth}>
      {/* Bill sections - skip if skipBill is true */}
      {!skipBill && (
        <>
          {/* Store details */}
          {renderStoreDetails008(retailDetails, scaledImg)}

          {/* Order header */}
          {renderOrderHeader007(
            isB2cOrder,
            isDeliveryOrder,
            reprint,
            orderId,
            invoiceId,
            baseOrderResponse,
            baseDetails,
            date,
            returnId,
            imgBase64,
            printType,
            saleMode,
            branchSubType,
            tokenNumber
          )}

          {/* Order items */}
          {renderOrderItemsGst006(
            noGst,
            gst1slab,
            gst2slab,
            gst5slab,
            gst6slab,
            gst9slab,
            gst14slab,
            gst20slab,
            freeProducts
          )}

          {/* Payment details */}
          {renderPaymentDetails006(
            baseOrderResponse,
            baseDetails,
            printType,
            gstBreakupDetails,
            saleMode
          )}

          {/* Footer */}
          {renderFooter006(
            {
              isB2cOrder,
              isDeliveryOrder,
              baseOrderResponse,
              deliveryAddress,
              cashDrawerOpen,
              printType,
              baseDetails,
              saleMode,
            },
            template003
          )}
        </>
      )}

      {/* Conditional KOT Token Rendering - skip if skipKot is true */}
      {!skipKot &&
        (() => {
          let printerAgentConnected = false;

          try {
            printerAgentConnected = JSON.parse(localStorage.getItem("sendToKitchen") || "false");
          } catch {
            printerAgentConnected = false;
          }

          const shouldPrintToken =
            branchSubType !== "FINE_DINE" || (!printerAgentConnected && saleMode !== "DINE_IN");

          return (
            shouldPrintToken &&
            (storedOrgConfig?.kotTemplateId === "token002"
              ? renderToken002(
                  baseOrderResponse,
                  tokenNumber,
                  noGst,
                  gst1slab,
                  gst2slab,
                  gst5slab,
                  gst6slab,
                  gst9slab,
                  gst14slab,
                  gst20slab,
                  freeProducts
                )
              : renderToken(
                  baseOrderResponse,
                  tokenNumber,
                  noGst,
                  gst1slab,
                  gst2slab,
                  gst5slab,
                  gst6slab,
                  gst9slab,
                  gst14slab,
                  gst20slab,
                  freeProducts
                ))
          );
        })()}
    </Printer>
  );
};

export const renderPicklist = async (props) => {
  const {
    printerWidth,
    orderTokenDetails,
    orderId,
    pickerName,
    baseOrderResponse,
    date,
    orderItems,
    totalQuantity,
    orgConfig,
    templateId,
    retailType: propRetailType,
    useVariantName: directUseVariantName,
  } = props;

  const currentRetailType = (
    propRetailType ||
    localStorage.getItem("retailType") ||
    getFromLocalStorage("retailType") ||
    ""
  ).toUpperCase();
  const isGrocery = currentRetailType === "GROCERY";

  const storedOrgConfig = orgConfig || getFromLocalStorage("orgConfig") || {};
  const activeTemplateId = templateId || storedOrgConfig?.templateId;
  const rawOrgConfigStr = localStorage.getItem("orgConfig") || "";

  const isTemplate00201 =
    activeTemplateId === "template_002_01" ||
    rawOrgConfigStr.includes("template_002_01") ||
    localStorage.getItem("templateId") === "template_002_01" ||
    localStorage.getItem("template") === "template_002_01";

  const useVariantName =
    directUseVariantName !== undefined
      ? directUseVariantName
      : isGrocery && isTemplate00201;

  const isInstantDelivery = baseOrderResponse?.deliveryType === "INSTANT";

  const qrData = JSON.stringify({
    orderId,
    orderStatus: baseOrderResponse?.fulfilmentStatus,
  });

  return await render(
    <Printer type="epson" width={printerWidth}>
      <Line />
      <Text bold={true} align="center">
        PICK LIST
      </Text>
      <Line />
      <Text align="center">Token #{orderTokenDetails?.token || "N/A"}</Text>
      <Text align="center">Order #{orderId || "N/A"}</Text>
      <Text align="center" bold={true} size={{ width: 2, height: 2 }}>
        {convertToLocalTime(baseOrderResponse?.startTime)}-
        {convertToLocalTime(baseOrderResponse?.endTime)}
      </Text>
      {isInstantDelivery && (
        <Text align="center" bold={true} size={{ width: 2, height: 2 }}>
          (INSTANT)
        </Text>
      )}
      <Line />
      <Text>Customer Name: {baseOrderResponse?.customerName || "N/A"}</Text>
      {/* <Text>Customer No: {baseOrderResponse?.mobileNumber || "N/A"}</Text> */}
      <Text>Order time: {date}</Text>
      <Line />
      <Text bold={true}>{"#   Items"}</Text>
      <Text bold={true}>{" UOM    Qty    MRP    SP    Barcode"}</Text>
      <Line />
      {orderItems?.map((e, i) => {
        const variantName = (e?.variantName || "").trim();
        const productName = e?.productName || "";
        const itemName = (useVariantName ? variantName || productName : productName) || "";
        const productNameParts = itemName.match(/.{1,38}/g) || [];

        return (
          <Fragment key={i}>
            {productNameParts.map((part, index) => (
              <Text bold key={index}>
                {index === 0
                  ? `${`${i + 1}`.slice(0, 3).padEnd(3)} ${part.padEnd(38)}`
                  : `    ${part}`}
              </Text>
            ))}
            <Text>{` ${(
              (e?.weightsAndMeasures?.gross_weight || "").toString() +
              (e?.weightsAndMeasures?.measurement_unit || "").toString()
            )
              .slice(0, 7)
              .padEnd(7)}${((e?.returnedQuantity ?? e?.quantityBySpecs ?? e?.quantity) || "N/A")
              .toString()
              .slice(0, 5)
              .padStart(5)}${(e?.mrp || "N/A").toString().slice(0, 7).padStart(7)}${(
              e?.sellingPrice || "N/A"
            )
              .toString()
              .slice(0, 6)
              .padStart(6)} ${`<${e?.gtin || "N/A"}>`.slice(0, 15).padStart(15)}`}</Text>
            <Br />
          </Fragment>
        );
      })}
      <Line />
      <Text bold={true} align="center" size={{ width: 2, height: 2 }}>
        {`Total Qty: ${totalQuantity}`}
      </Text>
      <Line />
      <QRCode align="center" height={150} content={qrData} />
      <Text align="center">Scan to get order details in ODS</Text>
      <Cut />
    </Printer>
  );
};

export const renderReport = async (props) => {
  const { printerWidth, sessionData } = props;
  const hasSodexo = getFromLocalStorage("paymentMethods")?.includes("SODEXO");
  const { firstName, secondName } = getFromLocalStorage("retailUserDetails");

  const isAmountGreater =
    sessionData?.sessionSalesData?.cashHandOver >= sessionData?.closingBalance;

  const currentTime = convertToLocalDateTime(new Date());

  return await render(
    <Printer type="epson" width={printerWidth}>
      <Line />
      <Text bold={true} align="center">
        SESSION REPORT
      </Text>
      <Line />
      <Text>Start Time: {convertToLocalDateTime(sessionData?.startTime) || "N/A"}</Text>
      <Text>Closing Time: {currentTime || "N/A"}</Text>
      <Text>
        {`Cashier Name: ${firstName && secondName ? `${firstName} ${secondName}` : "N/A"}`}
      </Text>
      <Text>Manager Name: {sessionData?.managerName || "N/A"}</Text>
      <Text>Terminal: {sessionData?.licenseName || "N/A"}</Text>
      <Line />
      <Text bold invert>
        Total Orders: {`${sessionData?.sessionSalesData?.totalOrders || "N/A"} `}
      </Text>

      <Text bold={true}>{`UPI      CARD     CASH     SPLIT    ${hasSodexo ? "SODEXO" : ""}`}</Text>
      <Text>
        {`${(sessionData?.sessionSalesData?.upiOrders || "N/A")?.toString()?.padEnd(9)}${(
          sessionData?.sessionSalesData?.cardOrders || "N/A"
        )
          ?.toString()
          ?.padEnd(9)}${(sessionData?.sessionSalesData?.cashOrders || "N/A")
          ?.toString()
          ?.padEnd(9)}${(sessionData?.sessionSalesData?.splitOrders || "N/A")
          ?.toString()
          .padEnd(9)}${hasSodexo ? sessionData?.sessionSalesData?.sodexoOrders || "N/A" : ""}`}
      </Text>
      <Br />
      <Text bold invert>
        Total Sales: {sessionData?.sessionSalesData?.totalOrdersValue || "N/A"}
      </Text>

      <Text bold={true}>{`UPI      CARD     CASH     ${hasSodexo ? "SODEXO" : ""}`}</Text>
      <Text>
        {`${(sessionData?.sessionSalesData?.upiOrdersValue || "N/A")?.toString()?.padEnd(9)}${(
          sessionData?.sessionSalesData?.cardOrdersValue || "N/A"
        )
          ?.toString()
          ?.padEnd(9)}${(sessionData?.sessionSalesData?.cashOrdersValue || "N/A")
          ?.toString()
          ?.padEnd(9)}${
          hasSodexo ? sessionData?.sessionSalesData?.sodexoOrdersValue || "N/A" : ""
        }`}
      </Text>
      <Line />
      <Text>Total Sales: {sessionData?.sessionSalesData?.totalOrdersValue || "N/A"}</Text>
      <Text>Opening Balance: {sessionData?.sessionCashAdvance || "N/A"}</Text>
      <Text>Cash Refunds: {sessionData?.sessionSalesData?.cashRefunds || "N/A"}</Text>
      <Line />

      <Text bold align="center">
        Cash Denominations
      </Text>
      {sessionData?.denominations?.map((e, i) => (
        <Text align="center" key={i}>{`${e.name.padEnd(5)}: ${e.count.toString().padEnd(5)}`}</Text>
      ))}

      <Line />
      <Text bold>
        Total Discrepancy Amount: {isAmountGreater ? "-" : "+"}
        {Math.abs(
          Math.round(
            Number(sessionData?.sessionSalesData?.cashHandOver) -
              Number(sessionData?.closingBalance)
          )
        ) || 0}
      </Text>

      <Line />
      <Cut />
    </Printer>
  );
};

export const renderCreditSettlement = async (props) => {
  const { printerWidth, retailDetails, settlementData, date } = props;
  const { firstName, secondName } = getFromLocalStorage("retailUserDetails") || {};
  const {
    amount,
    paymentMethod,
    settlementId,
    customerName,
    customerMobile,
  } = settlementData || {};

  const paymentMethodDisplay = (paymentMethod || "CASH")
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/^\w/, (c) => c.toUpperCase());

  return await render(
    <Printer type="epson" width={printerWidth}>
      {renderStoreDetails(retailDetails)}

      <Text align="center" bold={true} size={{ width: 2, height: 2 }}>
        PAYMENT RECEIPT
      </Text>
      <Line />

      <Row left="Date:" right={date || convertToLocalDateTime(new Date())} />
      {settlementId && <Row left="Settlement ID:" right={String(settlementId)} />}
      <Row
        left={`Cashier: ${firstName && secondName ? `${firstName} ${secondName}` : firstName || "N/A"}`}
        right=""
      />
      <Line />

      <Row left="Customer:" right={customerName || "N/A"} />
      {customerMobile && <Row left="Mobile:" right={customerMobile} />}
      <Row left="Paid Via:" right={paymentMethodDisplay} />
      <Line character="=" />

      <Row
        left={
          <Text bold={true} size={{ width: 2, height: 2 }}>
            Amount Paid
          </Text>
        }
        right={
          <Text bold={true} size={{ width: 2, height: 2 }}>{`Rs.${amount ?? "0"}`}</Text>
        }
      />
      <Line character="=" />

      <Text align="center" bold={true}>
        Thank you for your payment!
      </Text>
      <Br />
      <Cut />
    </Printer>
  );
};

export const renderTokenStandalone = async (props) => {
  const {
    tableId,
    tokenNumber,
    tableNumber,
    subOrderType,
    customerName,
    orderItems,
    printerWidth,
    saleMode,
    comments,
    layoutName,
    startTime,
    endTime,
    slotId,
    orderId
  } = props;
  const storedOrgConfig = JSON.parse(localStorage.getItem("orgConfig")) || {};
  const orderIdLabel = storedOrgConfig?.templateId === "template_006_01" ? orderId : undefined;
  return await render(
    <Printer type="epson" width={printerWidth}>
      {storedOrgConfig?.kotTemplateId === "token002"
        ? renderToken007(
            tableId,
            tokenNumber,
            tableNumber,
            subOrderType,
            customerName,
            orderItems,
            saleMode,
            comments,
            layoutName,
            startTime,
            endTime,
            slotId,
            orderIdLabel
          )
        : renderToken006(
            tableId,
            tokenNumber,
            tableNumber,
            subOrderType,
            customerName,
            orderItems,
            saleMode,
            comments,
            layoutName,
            startTime,
            endTime,
            slotId,
            orderIdLabel
          )}
    </Printer>
  );
};

export const renderProduct = async (props) => {
  const { printerWidth, productData } = props;
  const LocName = localStorage.getItem("LocName");

  return await render(
    <Printer type="epson" width={printerWidth}>
      <Line />
      {/* Header */}
      <Text bold={true} align="center">
        {productData?.data?.restaurantName || "N/A"}
      </Text>
      <Text align="center">{productData?.data?.address || "N/A"}</Text>
      <Line />

      {/* Report Title */}
      <Text bold={true} align="center">
        {productData?.data?.reportTitle || "Department Wise Sales Report"}
      </Text>
      <Line />

      {/* Date Range */}
      <Text>{`From ${productData?.data?.fromDate || "N/A"} To ${
        productData?.data?.toDate || "N/A"
      }`}</Text>
      <Line />

      {/* Column Headers */}
      <Text bold={true}>Product Name      Qty     Grossamt</Text>
      <Line />

      {/* Department-wise Sales */}
      {productData?.data?.departmentSales?.map((category, index) => (
        <>
          {/* Category Name */}
          <Text bold={true}>{category.categoryName}</Text>
          <Br />

          {/* Products in Category */}
          {category.products?.map((product, prodIndex) => {
            const productName = (product.productName || "").slice(0, 25).padEnd(25);
            const qty = String(product.quantity ?? 0)
              .slice(0, 3)
              .padStart(3);
            const amount = String((product.grossAmount ?? 0).toFixed(2))
              .slice(0, 10)
              .padStart(10);

            return <Text key={prodIndex}>{`${productName} ${qty} ${amount}`}</Text>;
          })}

          <Line />
        </>
      ))}

      {/* Sales Breakup Detail */}
      <Text bold={true} align="center">
        Sales Breakup Summary-Detail
      </Text>
      <Line />
      <Text bold={true}>Particulars             Amount</Text>
      <Line />

      <Text>{`${"Cash".padEnd(32)}${(productData?.data?.salesBreakupDetail?.cash ?? 0).toFixed(
        2
      )}`}</Text>
      <Text>{`${"UPI".padEnd(32)}${(productData?.data?.salesBreakupDetail?.upi ?? 0).toFixed(
        2
      )}`}</Text>
      <Text>{`${"Card".padEnd(32)}${(productData?.data?.salesBreakupDetail?.card ?? 0).toFixed(
        2
      )}`}</Text>
      <Text>{`${"Cash+Card".padEnd(32)}${(
        productData?.data?.salesBreakupDetail?.cashPlusCard ?? 0
      ).toFixed(2)}`}</Text>
      <Text>{`${"Cash In Drawer".padEnd(32)}${(
        productData?.data?.salesBreakupDetail?.cashInDrawer ?? 0
      ).toFixed(2)}`}</Text>
      <Text>{`${"Gross W/O Discount".padEnd(32)}${(
        productData?.data?.salesBreakupDetail?.grossWithoutDiscount ?? 0
      ).toFixed(2)}`}</Text>
      <Text>{`${"Customer Discount".padEnd(32)}${(
        productData?.data?.salesBreakupDetail?.customerDiscount ?? 0
      ).toFixed(2)}`}</Text>
      <Text>{`${"Complimentary Discount".padEnd(32)}${(
        productData?.data?.salesBreakupDetail?.complimentaryDiscount ?? 0
      ).toFixed(2)}`}</Text>
      <Text>{`${"Net Sales W/O GST".padEnd(32)}${(
        productData?.data?.salesBreakupDetail?.netSalesWithoutVat ?? 0
      ).toFixed(2)}`}</Text>
      
      <Text>{`${"ROD".padEnd(32)}${(productData?.data?.salesBreakupDetail?.rod ?? 0).toFixed(
        2
      )}`}</Text>
      <Text>{`${"Net Sales With GST".padEnd(32)}${(
        productData?.data?.salesBreakupDetail?.netSalesWithVat ?? 0
      ).toFixed(2)}`}</Text>

      <Line />

      {/* Sales Breakup Summary */}
      <Text bold={true} align="center">
        Sales Breakup Summary-smry
      </Text>
      <Line />
      <Text bold={true}>Delivery Name      NoofBills       BillAmount</Text>
      <Line />

      {productData?.data?.salesBreakupSummary?.deliveryTypeSales?.map((delivery, index) => {
        const deliveryName = (delivery.deliveryName || "").slice(0, 20).padEnd(20);
        const bills = String(delivery.numberOfBills ?? 0)
          .slice(0, 8)
          .padStart(8);
        const amount = String((delivery.billAmount ?? 0).toFixed(2))
          .slice(0, 12)
          .padStart(12);

        return <Text key={index}>{`${deliveryName} ${bills} ${amount}`}</Text>;
      })}

      <Line />

      {/* Grand Total */}
      <Text bold={true}>
        {`${"Grand Total".padEnd(20)} ${String(
          productData?.data?.salesBreakupSummary?.grandTotalBills ?? 0
        ).padStart(8)} ${String(
          (productData?.data?.salesBreakupSummary?.grandTotalAmount ?? 0).toFixed(2)
        ).padStart(12)}`}
      </Text>

      <Line />
      <Cut />
    </Printer>
  );
};
